{
  "auth": {
    "user_pool_id": "eu-west-1_SwCnp7Fvo",
    "aws_region": "eu-west-1",
    "user_pool_client_id": "50nlpeo7osb5mml2usekfdo3su",
    "identity_pool_id": "eu-west-1:ed88df16-a7a4-49bd-9943-b355118812db",
    "mfa_methods": [],
    "standard_required_attributes": [
      "email"
    ],
    "username_attributes": [
      "email"
    ],
    "user_verification_types": [
      "email"
    ],
    "groups": [
      {
        "SUPERADMIN": {
          "precedence": 0
        }
      },
      {
        "ADMIN": {
          "precedence": 1
        }
      },
      {
        "EMPLOYEE": {
          "precedence": 2
        }
      }
    ],
    "mfa_configuration": "NONE",
    "password_policy": {
      "min_length": 8,
      "require_lowercase": true,
      "require_numbers": true,
      "require_symbols": true,
      "require_uppercase": true
    },
    "unauthenticated_identities_enabled": true
  },
  "data": {
    "url": "https://euxijwmxazcafnazcby4pwkm5a.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_region": "eu-west-1",
    "api_key": "da2-herkiint6ve6fbh3dcort4mr44",
    "default_authorization_type": "AMAZON_COGNITO_USER_POOLS",
    "authorization_types": [
      "API_KEY",
      "AWS_IAM"
    ],
    "model_introspection": {
      "version": 1,
      "models": {
        "ChecklistItem": {
          "name": "ChecklistItem",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "taskId": {
              "name": "taskId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "task": {
              "name": "task",
              "isArray": false,
              "type": {
                "model": "Task"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "taskId"
                ]
              }
            },
            "label": {
              "name": "label",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "done": {
              "name": "done",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "order": {
              "name": "order",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "doneBy": {
              "name": "doneBy",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "doneAt": {
              "name": "doneAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ChecklistItems",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTaskIdAndOrder",
                "queryField": "listChecklistItemsByTaskId",
                "fields": [
                  "taskId",
                  "order"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ChecklistTemplate": {
          "name": "ChecklistTemplate",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "items": {
              "name": "items",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": false
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ChecklistTemplates",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create",
                      "read",
                      "update"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Comment": {
          "name": "Comment",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "imagePaths": {
              "name": "imagePaths",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": true,
              "attributes": []
            },
            "createdBy": {
              "name": "createdBy",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "taskId": {
              "name": "taskId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "task": {
              "name": "task",
              "isArray": false,
              "type": {
                "model": "Task"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "taskId"
                ]
              }
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Comments",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTaskId",
                "queryField": "listCommentsByTaskId",
                "fields": [
                  "taskId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "create",
                      "read"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read",
                      "create"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "User": {
          "name": "User",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "cognitoId": {
              "name": "cognitoId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": false,
              "attributes": []
            },
            "phone": {
              "name": "phone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "role": {
              "name": "role",
              "isArray": false,
              "type": {
                "enum": "UserRole"
              },
              "isRequired": false,
              "attributes": []
            },
            "isArchived": {
              "name": "isArchived",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "archivedAt": {
              "name": "archivedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "settings": {
              "name": "settings",
              "isArray": false,
              "type": {
                "model": "UserSettings"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "HAS_ONE",
                "associatedWith": [
                  "userId"
                ],
                "targetNames": []
              }
            },
            "tenants": {
              "name": "tenants",
              "isArray": true,
              "type": {
                "model": "UserTenant"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "managedProjects": {
              "name": "managedProjects",
              "isArray": true,
              "type": {
                "model": "ProjectManager"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "projectMemberships": {
              "name": "projectMemberships",
              "isArray": true,
              "type": {
                "model": "ProjectMember"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "todos": {
              "name": "todos",
              "isArray": true,
              "type": {
                "model": "TodoUser"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Users",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "read",
                      "update"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "UserSettings": {
          "name": "UserSettings",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "secondsToAvoid": {
              "name": "secondsToAvoid",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "aiInvoicePrompt": {
              "name": "aiInvoicePrompt",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "dashboardSettings": {
              "name": "dashboardSettings",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": []
            },
            "displayModeForProject": {
              "name": "displayModeForProject",
              "isArray": false,
              "type": {
                "enum": "UserSettingsDisplayModeForProject"
              },
              "isRequired": false,
              "attributes": []
            },
            "activitySplitPosition": {
              "name": "activitySplitPosition",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "defaultTenantId": {
              "name": "defaultTenantId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "googleCalendarRefreshToken": {
              "name": "googleCalendarRefreshToken",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "googleCalendarConnected": {
              "name": "googleCalendarConnected",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "googleCalendarEnabledIds": {
              "name": "googleCalendarEnabledIds",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "UserSettings",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byUserId",
                "queryField": "listSettingsByUserId",
                "fields": [
                  "userId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "identityClaim": "cognito:username"
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Client": {
          "name": "Client",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": false,
              "attributes": []
            },
            "phone": {
              "name": "phone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "address": {
              "name": "address",
              "isArray": false,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": []
            },
            "fullAddress": {
              "name": "fullAddress",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "type": {
              "name": "type",
              "isArray": false,
              "type": {
                "enum": "ClientType"
              },
              "isRequired": false,
              "attributes": []
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "clientContacts": {
              "name": "clientContacts",
              "isArray": true,
              "type": {
                "model": "ClientContact"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "clientId"
                ]
              }
            },
            "todos": {
              "name": "todos",
              "isArray": true,
              "type": {
                "model": "TodoClient"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "clientId"
                ]
              }
            },
            "projects": {
              "name": "projects",
              "isArray": true,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "clientId"
                ]
              }
            },
            "directTodos": {
              "name": "directTodos",
              "isArray": true,
              "type": {
                "model": "Todo"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "clientId"
                ]
              }
            },
            "tenants": {
              "name": "tenants",
              "isArray": true,
              "type": {
                "model": "TenantClient"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "clientId"
                ]
              }
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Clients",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "clientsByTenantId",
                "queryField": "listClientByTenantId",
                "fields": [
                  "tenantId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "create",
                      "update"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ClientContact": {
          "name": "ClientContact",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "clientId": {
              "name": "clientId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "client": {
              "name": "client",
              "isArray": false,
              "type": {
                "model": "Client"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "clientId"
                ]
              }
            },
            "contactId": {
              "name": "contactId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "contact": {
              "name": "contact",
              "isArray": false,
              "type": {
                "model": "Contact"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "contactId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ClientContacts",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byClientId",
                "queryField": "listClientContactsByClientId",
                "fields": [
                  "clientId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byContactId",
                "queryField": "listClientContactsByContactId",
                "fields": [
                  "contactId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "create",
                      "update"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Contact": {
          "name": "Contact",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": false,
              "attributes": []
            },
            "phone": {
              "name": "phone",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "clientContacts": {
              "name": "clientContacts",
              "isArray": true,
              "type": {
                "model": "ClientContact"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "contactId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Contacts",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "create",
                      "update"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ModelPhase": {
          "name": "ModelPhase",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "modelName": {
              "name": "modelName",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "phases": {
              "name": "phases",
              "isArray": true,
              "type": {
                "model": "Phase"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "modelPhaseId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ModelPhases",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Notification": {
          "name": "Notification",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "taskId": {
              "name": "taskId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "todoId": {
              "name": "todoId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "recipientId": {
              "name": "recipientId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "isRead": {
              "name": "isRead",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "senderName": {
              "name": "senderName",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Notifications",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "recipientId",
                    "allow": "owner",
                    "operations": [
                      "read",
                      "update",
                      "delete"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "create"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Phase": {
          "name": "Phase",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "color": {
              "name": "color",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "order": {
              "name": "order",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "links": {
              "name": "links",
              "isArray": true,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "modelPhaseId": {
              "name": "modelPhaseId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "estimatedHours": {
              "name": "estimatedHours",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "modelPhase": {
              "name": "modelPhase",
              "isArray": false,
              "type": {
                "model": "ModelPhase"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "modelPhaseId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Phases",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byModelPhaseId",
                "queryField": "listPhasesByModelPhaseId",
                "fields": [
                  "modelPhaseId",
                  "order"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Project": {
          "name": "Project",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "projectName": {
              "name": "projectName",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true,
              "attributes": []
            },
            "order": {
              "name": "order",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "stages": {
              "name": "stages",
              "isArray": true,
              "type": {
                "model": "ProjectStage"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectId"
                ]
              }
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "links": {
              "name": "links",
              "isArray": true,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "estimatedHours": {
              "name": "estimatedHours",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "ProjectStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "archivedAt": {
              "name": "archivedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "tenant": {
              "name": "tenant",
              "isArray": false,
              "type": {
                "model": "Tenant"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "tenantId"
                ]
              }
            },
            "managers": {
              "name": "managers",
              "isArray": true,
              "type": {
                "model": "ProjectManager"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectId"
                ]
              }
            },
            "members": {
              "name": "members",
              "isArray": true,
              "type": {
                "model": "ProjectMember"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectId"
                ]
              }
            },
            "clientId": {
              "name": "clientId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "client": {
              "name": "client",
              "isArray": false,
              "type": {
                "model": "Client"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "clientId"
                ]
              }
            },
            "todos": {
              "name": "todos",
              "isArray": true,
              "type": {
                "model": "Todo"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectId"
                ]
              }
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Projects",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ProjectStage": {
          "name": "ProjectStage",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true,
              "attributes": []
            },
            "endDate": {
              "name": "endDate",
              "isArray": false,
              "type": "AWSDate",
              "isRequired": true,
              "attributes": []
            },
            "stageName": {
              "name": "stageName",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "color": {
              "name": "color",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "ProjectStageStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "order": {
              "name": "order",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "estimatedHours": {
              "name": "estimatedHours",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "links": {
              "name": "links",
              "isArray": true,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "project": {
              "name": "project",
              "isArray": false,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectId"
                ]
              }
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "tasks": {
              "name": "tasks",
              "isArray": true,
              "type": {
                "model": "Task"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "projectStageId"
                ]
              }
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ProjectStages",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byProjectId",
                "queryField": "listStagesByProjectId",
                "fields": [
                  "projectId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "read",
                      "update",
                      "create",
                      "delete"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ProjectManager": {
          "name": "ProjectManager",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "project": {
              "name": "project",
              "isArray": false,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectId"
                ]
              }
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ProjectManagers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byProjectId",
                "queryField": "listManagersByProject",
                "fields": [
                  "projectId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byUserId",
                "queryField": "listProjectsByManager",
                "fields": [
                  "userId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "ProjectMember": {
          "name": "ProjectMember",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "project": {
              "name": "project",
              "isArray": false,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectId"
                ]
              }
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "ProjectMembers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byProjectId",
                "queryField": "listMembersByProject",
                "fields": [
                  "projectId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byUserId",
                "queryField": "listProjectsByMember",
                "fields": [
                  "userId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Task": {
          "name": "Task",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "nameTask": {
              "name": "nameTask",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "TaskStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "priority": {
              "name": "priority",
              "isArray": false,
              "type": {
                "enum": "TaskPriority"
              },
              "isRequired": false,
              "attributes": []
            },
            "startDate": {
              "name": "startDate",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "limitDateToDo": {
              "name": "limitDateToDo",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "order": {
              "name": "order",
              "isArray": false,
              "type": "Int",
              "isRequired": false,
              "attributes": []
            },
            "employeeId": {
              "name": "employeeId",
              "isArray": true,
              "type": "ID",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "estimatedHours": {
              "name": "estimatedHours",
              "isArray": false,
              "type": "Float",
              "isRequired": false,
              "attributes": []
            },
            "links": {
              "name": "links",
              "isArray": true,
              "type": "AWSJSON",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "comments": {
              "name": "comments",
              "isArray": true,
              "type": {
                "model": "Comment"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "taskId"
                ]
              }
            },
            "checklist": {
              "name": "checklist",
              "isArray": true,
              "type": {
                "model": "ChecklistItem"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "taskId"
                ]
              }
            },
            "projectStageId": {
              "name": "projectStageId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "projectStage": {
              "name": "projectStage",
              "isArray": false,
              "type": {
                "model": "ProjectStage"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectStageId"
                ]
              }
            },
            "validatedBy": {
              "name": "validatedBy",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "validatedAt": {
              "name": "validatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Tasks",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byProjectStageId",
                "queryField": "listTasksByStageId",
                "fields": [
                  "projectStageId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byProjectStageIdAndOrder",
                "queryField": "listTasksByStageOrdered",
                "fields": [
                  "projectStageId",
                  "order"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byValidatedBy",
                "queryField": "listTasksByValidator",
                "fields": [
                  "validatedBy"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "create",
                      "update",
                      "read",
                      "delete"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read",
                      "update",
                      "create"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "TaskAudit": {
          "name": "TaskAudit",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "taskId": {
              "name": "taskId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "field": {
              "name": "field",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "action": {
              "name": "action",
              "isArray": false,
              "type": {
                "enum": "TaskAuditAction"
              },
              "isRequired": false,
              "attributes": []
            },
            "oldValue": {
              "name": "oldValue",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "newValue": {
              "name": "newValue",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "changedBy": {
              "name": "changedBy",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "changedAt": {
              "name": "changedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": true,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "TaskAudits",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTaskIdAndChangedAt",
                "queryField": "listTaskAuditsByTaskId",
                "fields": [
                  "taskId",
                  "changedAt"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "provider": "userPools",
                    "ownerField": "owner",
                    "allow": "owner",
                    "operations": [
                      "read",
                      "create"
                    ],
                    "identityClaim": "cognito:username"
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read",
                      "create"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Tenant": {
          "name": "Tenant",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "isActive": {
              "name": "isActive",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "UserTenant"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "tenantId"
                ]
              }
            },
            "projects": {
              "name": "projects",
              "isArray": true,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "tenantId"
                ]
              }
            },
            "todos": {
              "name": "todos",
              "isArray": true,
              "type": {
                "model": "Todo"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "tenantId"
                ]
              }
            },
            "clients": {
              "name": "clients",
              "isArray": true,
              "type": {
                "model": "TenantClient"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "tenantId"
                ]
              }
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "Tenants",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "TimeEntries": {
          "name": "TimeEntries",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "imagePaths": {
              "name": "imagePaths",
              "isArray": true,
              "type": "String",
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true
            },
            "projectName": {
              "name": "projectName",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "stageId": {
              "name": "stageId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "employeeId": {
              "name": "employeeId",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "startTime": {
              "name": "startTime",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": true,
              "attributes": []
            },
            "endTime": {
              "name": "endTime",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": true,
              "attributes": []
            },
            "billable": {
              "name": "billable",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "approvalStatus": {
              "name": "approvalStatus",
              "isArray": false,
              "type": {
                "enum": "TimeEntriesApprovalStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "TimeEntries",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byProjectId",
                "queryField": "listTimeEntriesByProjectId",
                "fields": [
                  "projectId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byEmployeeId",
                "queryField": "listTimeEntriesByEmployeeId",
                "fields": [
                  "employeeId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "provider": "userPools",
                    "ownerField": "employeeId",
                    "allow": "owner",
                    "operations": [
                      "read",
                      "create",
                      "update",
                      "delete"
                    ],
                    "identityClaim": "cognito:username"
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "UserTenant": {
          "name": "UserTenant",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "tenant": {
              "name": "tenant",
              "isArray": false,
              "type": {
                "model": "Tenant"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "tenantId"
                ]
              }
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "UserTenants",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTenantId",
                "queryField": "listUserTenantsByTenantId",
                "fields": [
                  "tenantId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byUserId",
                "queryField": "listUserTenantsByUserId",
                "fields": [
                  "userId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "Todo": {
          "name": "Todo",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true,
              "attributes": []
            },
            "description": {
              "name": "description",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "status": {
              "name": "status",
              "isArray": false,
              "type": {
                "enum": "TodoStatus"
              },
              "isRequired": false,
              "attributes": []
            },
            "priority": {
              "name": "priority",
              "isArray": false,
              "type": {
                "enum": "TodoPriority"
              },
              "isRequired": false,
              "attributes": []
            },
            "dueDate": {
              "name": "dueDate",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "users": {
              "name": "users",
              "isArray": true,
              "type": {
                "model": "TodoUser"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "todoId"
                ]
              }
            },
            "clients": {
              "name": "clients",
              "isArray": true,
              "type": {
                "model": "TodoClient"
              },
              "isRequired": false,
              "attributes": [],
              "isArrayNullable": true,
              "association": {
                "connectionType": "HAS_MANY",
                "associatedWith": [
                  "todoId"
                ]
              }
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "tenant": {
              "name": "tenant",
              "isArray": false,
              "type": {
                "model": "Tenant"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "tenantId"
                ]
              }
            },
            "clientId": {
              "name": "clientId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "client": {
              "name": "client",
              "isArray": false,
              "type": {
                "model": "Client"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "clientId"
                ]
              }
            },
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "project": {
              "name": "project",
              "isArray": false,
              "type": {
                "model": "Project"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "projectId"
                ]
              }
            },
            "creatorId": {
              "name": "creatorId",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "nameLower": {
              "name": "nameLower",
              "isArray": false,
              "type": "String",
              "isRequired": false,
              "attributes": []
            },
            "validatedBy": {
              "name": "validatedBy",
              "isArray": false,
              "type": "ID",
              "isRequired": false,
              "attributes": []
            },
            "validatedAt": {
              "name": "validatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            },
            "isDeleted": {
              "name": "isDeleted",
              "isArray": false,
              "type": "Boolean",
              "isRequired": false,
              "attributes": []
            },
            "deletedAt": {
              "name": "deletedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": []
            }
          },
          "syncable": true,
          "pluralName": "Todos",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "fields": [
                  "id"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "todosByTenantId",
                "queryField": "listTodoByTenantId",
                "fields": [
                  "tenantId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "todosByClientId",
                "queryField": "listTodoByClientId",
                "fields": [
                  "clientId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "todosByCreatorId",
                "queryField": "listTodoByCreatorId",
                "fields": [
                  "creatorId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "todosByValidatedBy",
                "queryField": "listTodoByValidatedBy",
                "fields": [
                  "validatedBy"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "TodoUser": {
          "name": "TodoUser",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "todoId": {
              "name": "todoId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "todo": {
              "name": "todo",
              "isArray": false,
              "type": {
                "model": "Todo"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "todoId"
                ]
              }
            },
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "user": {
              "name": "user",
              "isArray": false,
              "type": {
                "model": "User"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "userId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "TodoUsers",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTodoId",
                "queryField": "listUsersByTodo",
                "fields": [
                  "todoId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byUserId",
                "queryField": "listTodosByUser",
                "fields": [
                  "userId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "TodoClient": {
          "name": "TodoClient",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "todoId": {
              "name": "todoId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "todo": {
              "name": "todo",
              "isArray": false,
              "type": {
                "model": "Todo"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "todoId"
                ]
              }
            },
            "clientId": {
              "name": "clientId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "client": {
              "name": "client",
              "isArray": false,
              "type": {
                "model": "Client"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "clientId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "TodoClients",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTodoId",
                "queryField": "listClientsByTodo",
                "fields": [
                  "todoId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byClientId",
                "queryField": "listTodosByClient",
                "fields": [
                  "clientId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "delete",
                      "read",
                      "update"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        },
        "TenantClient": {
          "name": "TenantClient",
          "fields": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "clientId": {
              "name": "clientId",
              "isArray": false,
              "type": "ID",
              "isRequired": true,
              "attributes": []
            },
            "tenant": {
              "name": "tenant",
              "isArray": false,
              "type": {
                "model": "Tenant"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "tenantId"
                ]
              }
            },
            "client": {
              "name": "client",
              "isArray": false,
              "type": {
                "model": "Client"
              },
              "isRequired": false,
              "attributes": [],
              "association": {
                "connectionType": "BELONGS_TO",
                "targetNames": [
                  "clientId"
                ]
              }
            },
            "createdAt": {
              "name": "createdAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            },
            "updatedAt": {
              "name": "updatedAt",
              "isArray": false,
              "type": "AWSDateTime",
              "isRequired": false,
              "attributes": [],
              "isReadOnly": true
            }
          },
          "syncable": true,
          "pluralName": "TenantClients",
          "attributes": [
            {
              "type": "model",
              "properties": {}
            },
            {
              "type": "key",
              "properties": {
                "name": "byTenantId",
                "queryField": "listClientsByTenant",
                "fields": [
                  "tenantId"
                ]
              }
            },
            {
              "type": "key",
              "properties": {
                "name": "byClientId",
                "queryField": "listTenantsByClient",
                "fields": [
                  "clientId"
                ]
              }
            },
            {
              "type": "auth",
              "properties": {
                "rules": [
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "SUPERADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "create",
                      "read",
                      "update",
                      "delete"
                    ],
                    "groups": [
                      "ADMIN"
                    ]
                  },
                  {
                    "groupClaim": "cognito:groups",
                    "provider": "userPools",
                    "allow": "groups",
                    "operations": [
                      "read"
                    ],
                    "groups": [
                      "EMPLOYEE"
                    ]
                  },
                  {
                    "allow": "private",
                    "operations": [
                      "read"
                    ]
                  }
                ]
              }
            }
          ],
          "primaryKeyInfo": {
            "isCustomPrimaryKey": false,
            "primaryKeyFieldName": "id",
            "sortKeyFieldNames": []
          }
        }
      },
      "enums": {
        "UserRole": {
          "name": "UserRole",
          "values": [
            "SUPERADMIN",
            "ADMIN",
            "EMPLOYEE"
          ]
        },
        "UserSettingsDisplayModeForProject": {
          "name": "UserSettingsDisplayModeForProject",
          "values": [
            "GANTT",
            "LIST"
          ]
        },
        "ClientType": {
          "name": "ClientType",
          "values": [
            "CLIENT",
            "SUPPLIER",
            "ARCHITECT",
            "ENGINEER",
            "OTHER"
          ]
        },
        "ProjectStatus": {
          "name": "ProjectStatus",
          "values": [
            "ACTIVE",
            "STANDBY",
            "DONE",
            "ARCHIVED"
          ]
        },
        "ProjectStageStatus": {
          "name": "ProjectStageStatus",
          "values": [
            "NOTBEGIN",
            "INPROGRESS",
            "DONE"
          ]
        },
        "TaskStatus": {
          "name": "TaskStatus",
          "values": [
            "NOTBEGIN",
            "INPROGRESS",
            "DONE"
          ]
        },
        "TaskPriority": {
          "name": "TaskPriority",
          "values": [
            "LOW",
            "MEDIUM",
            "HIGH"
          ]
        },
        "TaskAuditAction": {
          "name": "TaskAuditAction",
          "values": [
            "CREATED",
            "UPDATED",
            "DELETED"
          ]
        },
        "TimeEntriesApprovalStatus": {
          "name": "TimeEntriesApprovalStatus",
          "values": [
            "DRAFT",
            "APPROVED"
          ]
        },
        "TodoStatus": {
          "name": "TodoStatus",
          "values": [
            "TODO",
            "IN_PROGRESS",
            "DONE"
          ]
        },
        "TodoPriority": {
          "name": "TodoPriority",
          "values": [
            "LOW",
            "MEDIUM",
            "HIGH"
          ]
        },
        "CreateUserCustomRole": {
          "name": "CreateUserCustomRole",
          "values": [
            "SUPERADMIN",
            "ADMIN",
            "EMPLOYEE"
          ]
        },
        "UpdateUserRoleRole": {
          "name": "UpdateUserRoleRole",
          "values": [
            "SUPERADMIN",
            "ADMIN",
            "EMPLOYEE"
          ]
        }
      },
      "nonModels": {},
      "queries": {
        "algoliaSearchKey": {
          "name": "algoliaSearchKey",
          "isArray": false,
          "type": "String",
          "isRequired": false
        },
        "callAi": {
          "name": "callAi",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "content": {
              "name": "content",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "system": {
              "name": "system",
              "isArray": false,
              "type": "String",
              "isRequired": true
            }
          }
        },
        "googleOAuthConfig": {
          "name": "googleOAuthConfig",
          "isArray": false,
          "type": "String",
          "isRequired": true,
          "arguments": {
            "platform": {
              "name": "platform",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        }
      },
      "mutations": {
        "createUserCustom": {
          "name": "createUserCustom",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "name": {
              "name": "name",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "email": {
              "name": "email",
              "isArray": false,
              "type": "AWSEmail",
              "isRequired": true
            },
            "phone": {
              "name": "phone",
              "isArray": false,
              "type": "AWSPhone",
              "isRequired": false
            },
            "role": {
              "name": "role",
              "isArray": false,
              "type": {
                "enum": "CreateUserCustomRole"
              },
              "isRequired": false
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "tempPassword": {
              "name": "tempPassword",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        },
        "deleteUserCustom": {
          "name": "deleteUserCustom",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "archiveUserCustom": {
          "name": "archiveUserCustom",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "id": {
              "name": "id",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "archived": {
              "name": "archived",
              "isArray": false,
              "type": "Boolean",
              "isRequired": true
            }
          }
        },
        "deletePhaseModelCustom": {
          "name": "deletePhaseModelCustom",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "modelId": {
              "name": "modelId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "deleteProjectCustom": {
          "name": "deleteProjectCustom",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "projectId": {
              "name": "projectId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "deleteProjectStageCustom": {
          "name": "deleteProjectStageCustom",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "stageId": {
              "name": "stageId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            }
          }
        },
        "updateUserRole": {
          "name": "updateUserRole",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "userId": {
              "name": "userId",
              "isArray": false,
              "type": "ID",
              "isRequired": true
            },
            "role": {
              "name": "role",
              "isArray": false,
              "type": {
                "enum": "UpdateUserRoleRole"
              },
              "isRequired": false
            }
          }
        },
        "AdminInviteUser": {
          "name": "AdminInviteUser",
          "isArray": false,
          "type": "String",
          "isRequired": false,
          "arguments": {
            "email": {
              "name": "email",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "tenantId": {
              "name": "tenantId",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "firstName": {
              "name": "firstName",
              "isArray": false,
              "type": "String",
              "isRequired": false
            },
            "lastName": {
              "name": "lastName",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        },
        "googleOAuthExchange": {
          "name": "googleOAuthExchange",
          "isArray": false,
          "type": "String",
          "isRequired": true,
          "arguments": {
            "code": {
              "name": "code",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "redirectUri": {
              "name": "redirectUri",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "platform": {
              "name": "platform",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        },
        "googleOAuthRefresh": {
          "name": "googleOAuthRefresh",
          "isArray": false,
          "type": "String",
          "isRequired": true,
          "arguments": {
            "refreshToken": {
              "name": "refreshToken",
              "isArray": false,
              "type": "String",
              "isRequired": true
            },
            "platform": {
              "name": "platform",
              "isArray": false,
              "type": "String",
              "isRequired": false
            }
          }
        }
      }
    }
  },
  "storage": {
    "aws_region": "eu-west-1",
    "bucket_name": "amplify-d5rwvs9eoqqe2-sta-commenttimeentryimagebuc-9e87bcvcyots",
    "buckets": [
      {
        "name": "commentTimeEntryImage",
        "bucket_name": "amplify-d5rwvs9eoqqe2-sta-commenttimeentryimagebuc-9e87bcvcyots",
        "aws_region": "eu-west-1",
        "paths": {
          "commentImage/*": {
            "authenticated": [
              "get",
              "list",
              "write"
            ],
            "groupsSUPERADMIN": [
              "delete",
              "get",
              "list",
              "write"
            ],
            "groupsADMIN": [
              "delete",
              "get",
              "list",
              "write"
            ]
          },
          "timeEntryImage/*": {
            "authenticated": [
              "get",
              "list",
              "write"
            ],
            "groupsSUPERADMIN": [
              "delete",
              "get",
              "list",
              "write"
            ],
            "groupsADMIN": [
              "delete",
              "get",
              "list",
              "write"
            ]
          }
        }
      }
    ]
  },
  "version": "1.4"
}